export default (that) => [
  {
    text: that.$l('INDEX.btn_print') || '打印',
    icon: 'el-icon-printer',
    menuType: 'print',
    // divided: true,
    allow: 'E',
    data: {},
  },

]
